import { render, staticRenderFns } from "./locations.card.vue?vue&type=template&id=3b62994c&"
import script from "./locations.card.vue?vue&type=script&lang=js&"
export * from "./locations.card.vue?vue&type=script&lang=js&"
import style0 from "./locations.card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports